import backgroundimage from './svg/background.png'

const { default: styled } = require('styled-components')

const PageWrapper = styled.div`
  height: 100%;
  overflow: auto;
  background-color: #f0f8ff;
  .bg-wrapper {
    width: 100%;
  }
  .plan-container {
    margin: 15px 0px;
  }
  .pricing-background {
    background-image: url(${backgroundimage});
  }
  .title-wrapper {
    padding: 100px 0px;
  }
  .title {
    font-size: 48px;
    line-height: 1.5;
  }
  .sub-title {
    font-size: 18px;
    line-height: 1.5;
  }
`

const PlanWrapper = styled.div`
  margin: auto;
  /* width: 1180px; */
`

export { PageWrapper, PlanWrapper }
